import React from 'react';
import { ActiveBackground, Container, NavigationContent, NavigationItem } from './HomeNavigator.styles';
import { ReactComponent as HomeIcon } from '../../assets/icons/home-line.svg';
import { ReactComponent as YoutubeIcon } from '../../assets/icons/youtube.svg';
import { NavLink, useLocation } from 'react-router-dom';
import { FEED, REELS } from '../App/routes';
import { motion } from 'framer-motion';
import { Text10ExtraBold } from '../utils/Text/Text.styles';
import { getSafeAreaInset, triggerHaptic } from '../../utils/telegram';

const navigationItems = [
  { to: `/${FEED}`, label: 'Explore', Icon: HomeIcon },
  { to: `/${REELS}`, label: 'Reels', Icon: YoutubeIcon },
  // { to: `/${PROFILE}`, label: 'Profile', Icon: UserIcon },
];

const HomeNavigator = () => {
  const location = useLocation();
  const { bottom } = getSafeAreaInset();
  const activeIndex = Math.max(
    navigationItems.findIndex(({ to }) => location.pathname === to),
    0,
  );

  return (
    <Container style={{ bottom: `${bottom || 20}px` }}>
      <ActiveBackground
        animate={{ x: `${activeIndex * 100}%` }}
        transition={{ type: 'spring', stiffness: 380, damping: 30, mass: 0.85 }}
      />
      {navigationItems.map(({ to, label, Icon }) => (
        <NavigationItem key={to}>
          <NavLink to={to}>
            {({ isActive }) => (
              <NavigationContent $active={isActive} onClick={() => triggerHaptic()}>
                <motion.div
                  style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.4rem', zIndex: 1 }}
                  animate={{ scale: isActive ? 1.06 : 0.92, opacity: isActive ? 1 : 0.56, y: isActive ? -1 : 0 }}
                  transition={{ type: 'spring', stiffness: 400, damping: 24 }}>
                  <Icon />
                  <Text10ExtraBold>{label}</Text10ExtraBold>
                </motion.div>
              </NavigationContent>
            )}
          </NavLink>
        </NavigationItem>
      ))}
    </Container>
  );
};

export default HomeNavigator;
